module.exports = __webpack_public_path__ + "img/ic_star_dark.7a4a42bd.png";